var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-conteudo"},[(_setup.props?.pagamentoEletronico?.sigla == 'PEPA')?_c(_setup.LinhasDoPagamentoDePensaoAlimenticiaTabela,{attrs:{"pagamentoEletronico":_setup.props.pagamentoEletronico}}):_c(_setup.LinhasDoPagamentoTabela,{attrs:{"pagamentoEletronico":_setup.props.pagamentoEletronico}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }